import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../Assets/logo-icon.webp";

const NAV = [
  { label: "HOME", to: "/", key: "home" },
  { label: "ABOUT", to: "/about", key: "about" },
  { label: "PRICING", to: "/pricing", key: "pricing" },
  { label: "CONTACT", to: "/contact", key: "contact" },
];

const SharedHeader = ({ currentPage = "home" }) => {
  // Match the home header: transparent at the very top, switching to a blurred
  // glass bar once the user scrolls — so the header looks the same on every page
  // and doesn't visibly change when navigating between them.
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > 1);
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ease-out ${
        isScrolled
          ? "bg-gray-950/80 md:bg-gray-900/90 backdrop-blur-md border-b border-white/10 md:border-gray-800/50 shadow-lg"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-5 sm:px-6 md:px-8 lg:px-10">
        <div className="flex items-center justify-between h-16">
          {/* Logo and Brand */}
          <Link
            to="/"
            className="flex items-center hover:opacity-90 transition-opacity"
          >
            <img
              src={logo}
              alt=""
              className="w-10 h-10 md:w-12 md:h-12 mr-3 object-contain"
            />
            <span className="font-display text-lg md:text-xl font-bold bg-gradient-to-r from-blue-300 via-purple-300 to-pink-300 bg-clip-text text-transparent">
              AI Ebook Planner
            </span>
          </Link>

          {/* Navigation Menu — pill style */}
          <nav aria-label="Main" className="hidden md:flex items-center gap-1">
            {NAV.map((item) => (
              <Link
                key={item.key}
                to={item.to}
                className={`px-3.5 py-1.5 rounded-full text-sm font-medium transition-all ${
                  currentPage === item.key
                    ? "text-white bg-white/10 ring-1 ring-white/15"
                    : "text-gray-300 hover:text-white hover:bg-white/5"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <a
              href="https://www.facebook.com/aiebookplanner/"
              target="_blank"
              rel="noopener noreferrer"
              className="px-3.5 py-1.5 rounded-full text-sm font-medium text-gray-300 hover:text-white hover:bg-white/5 transition-all"
            >
              COMMUNITY
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default SharedHeader;
